import {
   View,
   Text,
   ImageBackground,
   Dimensions,
   Platform,
   Image,
   StyleSheet,
} from 'react-native';
import React from 'react';
import UISvg from '../../components/svg';
import UICircularProgress from '../../components/circular-progress';
import {
   FONT_FAMILY_REGULAR,
   drawerListBackgroundColor,
   isWindows,
   primaryColor500,
   primaryColor900,
   isWeb,
   isMacOS,
} from '../../utils/utils';

export const ProgressBarOld = props => {
   return props.percent > 0 ? (
      <ImageBackground
         source={require('../../assets/right_panel_bg.png')}
         style={{
            alignContent: 'center',
            padding: 20,
            ...Platform.select({
               web: {
                  maxHeight: '20vh',
                  minHeight: props.isLandscapeMode ? '20vh' : null,
                  display: 'flex',
                  justifyContent: 'center',
                  paddingHorizontal: 20,
                  paddingVertical:
                     Dimensions.get('window').height < 540
                        ? 0
                        : props.isLandscapeMode
                        ? '1vh'
                        : 16,
               },
            }),
         }}>
         <UISvg
            height={Platform.OS === 'web' ? '100%' : '200%'}
            width={Platform.OS === 'web' ? '100%' : '200%'}
            x1="0%"
            y1="100%"
            x2="0%"
            y2="0%"
            offset={['0%', '100%']}
            stopColor={['#003DA500', '#001231']}
            stopOpacity={['0', '1']}
         />
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
            }}>
            <Text
               style={{
                  flex: 1,
                  color: '#FFF',
                  fontSize: 20,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
                  width: '100%',
                  marginRight: '16%',
               }}>
               TRAINING COMPLETION PROGRESS
            </Text>
            <UICircularProgress
               size={100}
               width={8}
               fill={props.percent}
               rotation={0}
               tintColor="#26E555"
               background={true}
               backgroundColor={primaryColor900}
               trailStroke={primaryColor500}
               img={require('../../assets/course.png')}
               imgWidth={25}
               imgHeight={25}
            />
         </View>
      </ImageBackground>
   ) : null;
};
export const ProgressBarNew = props => {
   const remain = 100 - props.percent;
   const txtColor = props?.txtColor ?? '#FFF';
   return props.percent > 0 ? (
      <View
         style={{
            //flex: 1,
            backgroundColor: '#323B4A',
            maxHeight: isWeb ? '30%' : '34%',
            minHeight: props.isLandscapeMode ? '25%' : '30%',
            display: 'flex',
            justifyContent: 'space-between',
            paddingHorizontal: 20,
            paddingVertical: isWindows
               ? 10
               : Dimensions.get('window').height < 540
               ? 0
               : props.isLandscapeMode
               ? isWeb
                  ? 26
                  : 16
               : 16,
            ...Platform.select({
               web: {
                  maxHeight: null,
                  minHeight: props.isLandscapeMode ? '25vh' : '30vh',
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingHorizontal: 20,
                  paddingVertical:
                     Dimensions.get('window').height < 540
                        ? 0
                        : props.isLandscapeMode
                        ? 16
                        : 16,
               },
            }),
         }}>
         <UISvg
            height={Platform.OS === 'web' ? '100%' : '100%'}
            width={Platform.OS === 'web' ? '100%' : '200%'}
            x1="0%"
            y1="100%"
            x2="0%"
            y2="0%"
            offset={['0%', '100%']}
            stopColor={['#323B4A', '#202630']}
            stopOpacity={['0', '1']}
            rectWidth={'100%'}
            rectHeight={isMacOS ? '25%' : '100%'}
         />
         {/* 1st line */}
         <View style={styles.subContainerA}>
            <Image
               source={require('../../assets/course.png')}
               style={{
                  width: 28,
                  height: 28,
                  tintColor: '#FFF',
                  resizeMode: 'contain',
               }}
            />
            <Text
               style={{
                  color: txtColor,
                  fontWeight: '600',
                  fontSize: 12,
               }}>
               {remain}% Remaining
            </Text>
         </View>
         {/* 2nd line */}
         <View style={styles.subContainerB}>
            <UICircularProgress
               size={120}
               width={10}
               fill={props.percent}
               rotation={0}
               bgOpacity={1}
               tintColor="#26E555"
               background={true}
               backgroundColor={drawerListBackgroundColor}
               trailStroke={'rgb(82,82,82)'}
               img={require('../../assets/course.png')}
               imgWidth={25}
               imgHeight={25}
               onlyPercentage={true}
               percentFont={30}
               shadowColor={'grey'}
               //circleHeight={'100%'}
               //circleWidth={'28%'}
            />
         </View>
         {/* 3rd line */}
         <View style={styles.subContainerC}>
            <Text style={{color: txtColor, fontWeight: 'bold', fontSize: 10}}>
               TRAINING COMPLETION PROGRESS
            </Text>
         </View>
      </View>
   ) : null;
};
const styles = StyleSheet.create({
   container: {},
   subContainerA: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
   },
   subContainerB: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: Platform.OS !== 'web' ? 10 : null,
   },
   subContainerC: {
      marginTop: isWeb ? 5 : 10,
   },
});
export default ProgressBarNew;
